import React from 'react';
import { CARD_SURFACE, CARD_SURFACE_RAISED } from './uiTokens';
import type { CardProps } from './types/UIProps';

export type { CardProps };

export function Card({
  raised = false,
  padded = true,
  className = '',
  children,
  ...rest
}: CardProps): React.ReactElement {
  const surface = raised ? CARD_SURFACE_RAISED : CARD_SURFACE;
  const pad = padded ? 'p-4' : '';
  return (
    <div className={`${surface} ${pad} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export function Panel({
  className = '',
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <section className={`${CARD_SURFACE} ${className}`.trim()} {...rest}>
      {children}
    </section>
  );
}
